import type { Camera } from 'types/camera';
import { SpotDetails, SpotReportData } from 'types/spot';

const useCheckCameraSupportsInsights = (camera: Camera, spot: SpotDetails | SpotReportData) =>
  !!camera.supportsInsights && !!spot.insightsCameraId;

export default useCheckCameraSupportsInsights;
